function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#E0E0E0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7527 25.6479L13.1527 22.0479C12.6835 21.5787 12.6835 20.8203 13.1527 20.3511C13.6219 19.8819 14.3803 19.8819 14.8495 20.3511L17.5327 23.0343L25.0903 14.4195C25.5223 13.9155 26.2795 13.8579 26.7811 14.2887C27.2851 14.7207 27.3439 15.4767 26.9119 15.9795L18.5119 25.5795C18.2947 25.8339 17.9803 25.9851 17.6467 25.9983C17.2831 25.9995 16.9771 25.8735 16.7527 25.6479Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7527 25.6479L13.1527 22.0479C12.6835 21.5787 12.6835 20.8203 13.1527 20.3511C13.6219 19.8819 14.3803 19.8819 14.8495 20.3511L17.5327 23.0343L25.0903 14.4195C25.5223 13.9155 26.2795 13.8579 26.7811 14.2887C27.2851 14.7207 27.3439 15.4767 26.9119 15.9795L18.5119 25.5795C18.2947 25.8339 17.9803 25.9851 17.6467 25.9983C17.2831 25.9995 16.9771 25.8735 16.7527 25.6479Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgGreyCheck = function SvgGreyCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 16,
    height: 12
  }, _ref4), _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreyCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grey-check.3f6b7df0.svg";
export { ForwardRef as ReactComponent };